module.exports = __webpack_public_path__ + "img/hydrogen.a38a99d0.png";